import * as React from 'react';
import Transit from '../logic/domain/transits/Transit';
import { getHourMinute } from '../logic/util/DateTime';
import { addPath } from '../logic/service/RecordsForMonthService';
import TimeSelecter from './TimeSelecter';
// import { is, Map } from 'immutable';
import BaseComponent from './BaseComponent';
import pathToUpdate from 'src/logic/type/pathToUpdate';

interface Props {
  transit: Transit;
  handleUpdateRecord: Function;
  pathToUpdate: pathToUpdate;
}
interface State {
  isModalActive: boolean;
}

class TransitView extends BaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalActive: false
    };
  }
  // shouldComponentUpdate(nextProps: Props, nextState: State) {
  //   const propsDiff = is(Map(nextProps), Map(this.props));
  //   const stateDiff = is(Map(nextState), Map(this.state));
  //   return !(propsDiff && stateDiff);
  // }
  render() {
    const { transit, handleUpdateRecord, pathToUpdate } = this.props;
    const { isModalActive } = this.state;

    const handleOnChangeTime = (
      event: React.FormEvent<HTMLInputElement>
    ): void => {
      event.preventDefault();
      handleModalActive();
    };

    const handleOnChangeStation = (
      event: React.FormEvent<HTMLInputElement>
    ): void => {
      const path = addPath(pathToUpdate, ['station']);
      handleUpdateRecord(path, event.currentTarget.value);
    };

    const handleOnChangeDist = (
      event: React.FormEvent<HTMLInputElement>
    ): void => {
      const path = addPath(pathToUpdate, ['dist']);
      handleUpdateRecord(path, event.currentTarget.value);
    };

    // for modal
    const handleModalActive = () => {
      this.setState({
        isModalActive: !isModalActive
      });
    };

    const title = pathToUpdate.indexOf('from') > 0 ? 'EndTime' : 'StartTime';
    const transitTime =
      pathToUpdate.indexOf('from') > 0 ? transit.endTime : transit.startTime;
    const path = addPath(pathToUpdate, [
      pathToUpdate.indexOf('from') > 0 ? 'endTime' : 'startTime'
    ]);

    return (
      <div>
        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className="input"
                  type="text"
                  placeholder="10:00"
                  size={2}
                  value={getHourMinute(transitTime)}
                  onChange={e => handleOnChangeTime(e)}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-clock" />
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control is-expanded has-icons-left">
                <input
                  className="input"
                  type="text"
                  placeholder="出発駅"
                  size={8}
                  value={transit.station}
                  onChange={e => handleOnChangeStation(e)}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-train" />
                </span>{' '}
              </p>
            </div>
          </div>
        </div>
        <div className="field">
          <p className="control is-expanded has-icons-left">
            <input
              type="text"
              className="input"
              placeholder="訪問先"
              value={transit.dist}
              onChange={e => handleOnChangeDist(e)}
            />
            <span className="icon is-small is-left">
              <i className="fas fa-building" />
            </span>
          </p>
        </div>
        <TimeSelecter
          title={title}
          dateTime={transitTime}
          isActive={isModalActive}
          handleModalActive={handleModalActive}
          handleUpdateRecord={handleUpdateRecord}
          pathToUpdate={path}
        />
      </div>
    );
  }
}

export default TransitView;



// WEBPACK FOOTER //
// ./src/components/TransitView.tsx